import { buildTranscriptBodyForAnalysis } from "@/lib/fireflies/buildTranscriptBodyForAnalysis";
import type { FirefliesTranscriptDetail } from "@/types/fireflies";

export function formatFirefliesMarkdown(detail: FirefliesTranscriptDetail): string {
  const parts: string[] = [];
  parts.push(`# ${detail.title?.trim() || "Meeting transcript"}`);
  parts.push("");
  if (detail.date) {
    parts.push(`**Date:** ${new Date(detail.date).toISOString()}`);
  }
  if (detail.host_email) parts.push(`**Host:** ${detail.host_email}`);
  if (detail.duration != null) {
    parts.push(`**Duration:** ${Math.round(detail.duration)} minutes`);
  }
  if (detail.transcript_url) parts.push(`**Link:** ${detail.transcript_url}`);
  parts.push("");
  parts.push(buildTranscriptBodyForAnalysis(detail));
  return parts.join("\n");
}

export function firefliesMetadata(detail: FirefliesTranscriptDetail): Record<string, unknown> {
  return {
    fireflies: {
      transcriptId: detail.id,
      title: detail.title,
      date: detail.date,
      hostEmail: detail.host_email,
      transcriptUrl: detail.transcript_url,
    },
  };
}
